import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import { UpdateCustomCodeDefaultTaxCodeFragmentDoc } from './UpdateCustomCodeDefaultTaxCode.generated'
import * as Types from './purchasePlus_graphql'

export const AdvancedRequisitionLineModalLineFragmentDoc = gql`
  fragment AdvancedRequisitionLineModalLine on RequisitionLine {
    id
    uuid
    product {
      ...ProductItemProduct
    }
    supplier {
      id
      name
    }
    department {
      id
      name
    }
    account {
      id
      code
      codedName
    }
    taxCode {
      ...UpdateCustomCodeDefaultTaxCode
    }
  }
  ${ProductItemProductFragmentDoc}
  ${UpdateCustomCodeDefaultTaxCodeFragmentDoc}
` as unknown as DocumentNode<Types.AdvancedRequisitionLineModalLineFragment, unknown>
